import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = {
    key: 0,
    class: "df-field__req",
    "aria-hidden": "true"
};
import { computed } from "vue";
import { nextFieldId } from "../../composables/fieldId";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseField',
    props: {
        label: {},
        required: { type: Boolean },
        error: {},
        hint: {}
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const props = __props;
        const fieldId = nextFieldId();
        const hintId = `${fieldId}-hint`;
        const errorId = `${fieldId}-error`;
        const hasError = computed(() => !!props.error);
        const describedBy = computed(() => [props.hint ? hintId : undefined, hasError.value ? errorId : undefined]
            .filter(Boolean)
            .join(" ") || undefined);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["df-field", { 'df-field--error': hasError.value }])
            }, [
                _createElementVNode("label", {
                    class: "df-field__label",
                    for: _unref(fieldId)
                }, [
                    _createTextVNode(_toDisplayString(__props.label) + " ", 1 /* TEXT */),
                    (__props.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                        : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_1),
                (__props.hint)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        id: hintId,
                        class: "df-field__hint"
                    }, _toDisplayString(__props.hint), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _renderSlot(_ctx.$slots, "default", {
                    fieldId: _unref(fieldId),
                    describedBy: describedBy.value,
                    hasError: hasError.value
                }),
                (hasError.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        id: errorId,
                        class: "df-field__error",
                        role: "alert"
                    }, _toDisplayString(__props.error), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
